import { Facebook, Instagram, Twitter } from "react-feather";
import { Link } from "react-router-dom";

const ModernMinimalTemplate = ({ data, isStickyHeader }) => {

    return (<div style={{ fontFamily: "Arial, sans-serif", background: "#ffffff", color: "#111827", minHeight: "100vh" }}>
        <div style={{ maxWidth: "1450px", margin: "0 auto" }}>
            <header style={{ padding: "22px 50px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f1f1f1", position: isStickyHeader ? "sticky" : "relative", top: 0, zIndex: 999, background: "#ffffff" }}>
                <div style={{ width: '200px', height: 'auto' }}>
                    <img src={data && data?.logoURL ? data?.logoURL : "/images/logo.svg"} alt="logo" style={{ maxHeight: '67px' }} />
                </div>

                <nav style={{ display: "flex", gap: "35px", alignItems: "center" }}>
                    <Link to={"/sign-in"} style={navLink}>Sign In</Link>
                    <Link to={"/track-booking"} style={navLink}>Track</Link>
                    <button style={{ background: "#6d4cff", color: "#fff", border: "none", padding: "14px 28px", borderRadius: "10px", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}>{data && data?.phone ? data?.phone : ""}</button>
                </nav>
            </header>

            <section style={{ padding: "90px 60px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px", alignItems: "center" }}>
                <div>
                    <p style={{ color: "#6d4cff", fontWeight: "bold", marginBottom: "20px", fontSize: "18px" }}>{data && data?.heroTitle ? data?.heroTitle : ""}</p>
                    <h1 style={{ fontSize: "76px", lineHeight: "88px", marginBottom: "25px" }}>{data && data?.heroSubTitle ? data?.heroSubTitle : ""}</h1>
                    <p style={{ fontSize: "22px", lineHeight: "38px", color: "#555", maxWidth: "600px" }}>{data && data?.heroDescription ? data?.heroDescription : ""}</p>
                </div>

                <div>
                    <img src={data?.bannerImage ? data.bannerImage : "/images/template3-banner.png"} alt="truck" style={{ width: "100%" }} />
                </div>
            </section>

            <section style={{ padding: "70px 60px" }}>
                <div style={{ display: "flex", gap: "25px" }}>
                    {data?.services.map((item, index) => (<div key={index} style={{ border: "1px solid #ececec", padding: "40px 30px", textAlign: "center" }}>
                        <div style={{ fontSize: "55px", marginBottom: "20px", color: "#6d4cff" }}><img src={item?.icon} alt="icon" /></div>
                        <h3 style={{ fontSize: "28px", marginBottom: "15px" }}>{item.title}</h3>
                        <p style={{ color: "#666", fontSize: "18px", lineHeight: "30px" }}>{item.description}</p>
                    </div>))}
                </div>
            </section>

            <section style={{ padding: "90px 60px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "50px", alignItems: "center" }}>
                <div>
                    <h2 style={{ fontSize: "52px", marginBottom: "35px" }}>{data && data?.aboutTitle ? data?.aboutTitle : ""}</h2>
                    <div style={{ display: "flex", alignItems: "center", gap: "15px", fontSize: "22px", whiteSpace: 'pre-line' }}>{data && data?.aboutDescription ? data?.aboutDescription : ""}</div>
                </div>

                <div>
                    <img src={data && data?.aboutImage ? data?.aboutImage : "/images/template3-image.png"} alt="warehouse" style={{ width: "100%" }} />
                </div>
            </section>


        </div>

        <footer style={{ borderTop: "1px solid #ececec", background: "#f1f1f1", padding: "60px 285px 30px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "40px" }}>
                <div>
                    <h3 style={{ marginBottom: "20px", }}>Contact Info</h3>
                    <p>📞 {data && data?.phone ? data?.phone : ""}</p>
                    <p>✉️ {data && data?.email ? data?.email : "admin@eflogistics.io"}</p>
                    <p>📍 {data && data?.address ? data?.address : ""}</p>
                </div>

                <div>
                    <h3 style={{ marginBottom: "20px" }}>Follow Us</h3>
                    <div style={{ display: "flex", gap: "20px" }}>
                        <Link to={data && data?.facebookURL ? data?.facebookURL : "/"} target="_blank" style={socialIcon}><Facebook /></Link>
                        <Link to={data && data?.instagramURL ? data?.instagramURL : "/"} style={socialIcon}><Instagram /></Link>
                        <Link to={data && data?.twitterURL ? data?.twitterURL : "/"} style={socialIcon}><Twitter /></Link>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: "50px", borderTop: "1px solid #ececec", paddingTop: "20px", textAlign: "center", color: "#777" }}>{data && data?.copyRightText ? data?.copyRightText : ""}</div>
        </footer>
    </div>);
};

const navLink = {
    textDecoration: "none",
    color: "#111827",
    fontSize: "16px",
    fontWeight: "500",
};

const socialIcon = {
    color: "#000",
    textDecoration: "none",
    fontSize: "18px",
};

export default ModernMinimalTemplate;